import {VueConstructor} from "vue";
import {extend, ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, max, is, min_value} from "vee-validate/dist/rules";

extend('required', required);
extend('email', email);
extend('maxLength', max);
extend('is', is);
extend('min_value', min_value);

export default {
    install(vue: VueConstructor) {
        vue.component('ValidationField', ValidationProvider);
        vue.component('ValidationObserver', ValidationObserver);
    }
}